import { api } from '../core';
import { CASE_STATUS_TAG } from '../constants';
import { setCaseStatus } from '@/store';

export interface CaseStatusType {
  canSendForAi: boolean;
  sentForAi: boolean;
  status: string;
  canUploadDocuments: boolean;
  canClose: boolean;
  canClone: boolean;
  // True while the case is being copied, or is the copy still being created. Use this, not the status, to tell.
  isCloning: boolean;
}

export type GetCaseStatusResponse = CaseStatusType;

export interface GetCaseStatusProps {
  caseId: string;
}

const getCaseStatusApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getCaseStatus: builder.query<GetCaseStatusResponse, GetCaseStatusProps>({
      query: ({ caseId }: GetCaseStatusProps) => ({
        url: `case/status`,
        params: { caseId },
        method: 'GET',
      }),
      providesTags: (_result, _err, { caseId }) => [{ type: CASE_STATUS_TAG, id: caseId }],
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;

          if (data) {
            dispatch(setCaseStatus(data));
          }
        } catch (error) {
          if (error instanceof Error && error.name === 'AbortError') {
            console.log('Request was aborted');
          } else {
            console.error('Error in getCaseStatus in onQueryStarted:', error);
          }
        }
      },
      extraOptions: { maxRetries: 3 },
    }),
  }),
});

export const { useLazyGetCaseStatusQuery } = getCaseStatusApi;
